import React from "react";
import { useLocation, matchPath } from "react-router-dom";
import { loginSession, useLoginSession } from "../LoginSession";
import "../style/typography.scss";
import "../style/colors.scss";
import homeIcon from "../icon/dashboard/Home.svg";
import profileIcon from "../icon/dashboard/Person/Person.svg";
import supportIcon from "../icon/Headset.svg";
import logoutIcon from "../icon/dashboard/Log/Out.svg";
import Button from "./Button";
import sharedConfig from "../config";

const MainSideBar = ({ style }) => {
    const location = useLocation();

    const { userInfo } = useLoginSession(false);

    const ICON_SPACING_TOP = 41;
    const ICON_SPACING_BOTTOM = 50;
    const ICON_SIZE = 24;
    const BAR_WIDTH = 80;
    const BAR_MIN_WIDTH = 34;

    const links = [
        ...(userInfo?.single_app_ux ? [] : [{ svg: homeIcon, to: "hub" }]), // no home link if single app ux
        { svg: profileIcon, to: "account-management" },
        //todo: { svg: announcementsIcon, to: 'hub#Announcements' },
        //todo: { svg: faqIcon,           to: 'hub#KnowledgeBase' },
        { svg: supportIcon, to: "support" },
    ];

    const isCurrentPage = (to) => {
        const [path, hash] = to.split("#");
        return (
            !!matchPath({ path: path, exact: true, strict: false }, location.pathname) &&
            location.hash === (hash ? `#${hash}` : "")
        ); // check matching # portion of url todo: remove this once we aren't using hash links for demo purposes
    };

    //todo: remove
    const SideBarBtn = ({ active, ...restProps }) => {
        restProps.to = restProps.to ? `${sharedConfig.centralFrontendURL}${restProps.to}` : undefined;
        return (
            <Button
                {...restProps}
                className="lnk-color btn-xxl"
                style={{
                    ...restProps.style,
                    color: active ? "var(--colors-primary-slate-700)" : "var(--colors-primary-slate-200)",
                    padding: 0, // remove padding since we are doing our own spacing with flex
                }}
            />
        );
    };

    return (
        <div
            style={{
                ...style,
                minWidth: `${BAR_MIN_WIDTH}px`,
                width: `${BAR_WIDTH}px`,
                background: "var(--colors-base-00)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-evenly",
                    flex: 1,
                    maxHeight: `${links.length * (ICON_SPACING_TOP + ICON_SIZE) + ICON_SPACING_TOP /*calculate size needed to fit all the icons with desired spacing above below and in between*/}px`,
                }}
            >
                {links.map((l) => (
                    <SideBarBtn {...l} key={l.to} active={isCurrentPage(l.to)} />
                ))}
            </div>
            <div
                style={{
                    marginTop: "auto",
                    maxHeight: `${ICON_SIZE + ICON_SPACING_BOTTOM}px`,
                    flex: 1,
                }}
            >
                <SideBarBtn svg={logoutIcon} active onClick={() => loginSession.logout()} />
            </div>
        </div>
    );
};

export default MainSideBar;
